<template>
  <div>

    <div class="per" :style="{width:width}">
      <div :class="_per_remain" :style="{width:percent,backgroundColor:color}"></div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Progress',
    display: '进度条',
    data() {
      return {
        preCls: 'mc-progress',
      }
    },
    props: {
      percent: String,
      width: String,
      color: String,
      position: {
        type: String,
        default: 'left',
        validator(value) {
          let types = ['left','right','mid']
          return types.includes(value) || !value
        }
      }
    },
    computed: {
      _per_remain(){
        let {position} = this
        let className = [
          `per_remain`,
          {
            [`per_remain-${position}`]: !!position,
          },
        ]
        return className
      },

    },
    methods: {

    },
  }
</script>



// WEBPACK FOOTER //
// src/components/progress/progress.vue